import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initAnalytics } from './analytics'

const app = createApp(App)

app.use(router)

initAnalytics(router)

// Wait for the first page's code to load before mounting, so the prebuilt page
// content (scripts/prerender.js) stays on screen until the app can replace it
// with the same content.
router.isReady().then(() => app.mount('#app'))